<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <div class="row">
        <HeaderComp currentPage="about"></HeaderComp>

        <ServiceContent class="text-black" />

        <FooterComp></FooterComp>
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import HeaderComp from '@/components/layouts/HeaderComp'
import FooterComp from '@/components/layouts/FooterComp'
import ServiceContent from '@/views/content/ServiceContent'
import { IonContent, IonPage } from '@ionic/vue';
export default {
  components: { ServiceContent, FooterComp, HeaderComp, IonContent, IonPage },
  data() {
    return {}
  },
}
</script>
